import { userMap } from "./user";

export const surgicalPreAnestheticConsultationMap: GenericObject = {
	user: userMap,
};
